import '@dweidner/opt-in-element';

import {isPopoverSupported, whenStuck} from './utilities/dom.js';

import {Carousel} from './elements/carousel.js';
import {CarouselTrack} from './elements/carousel-track.js';
import {CarouselReel} from './elements/carousel-reel.js';
import {CarouselItem} from './elements/carousel-item.js';
import {CarouselPagination} from './elements/carousel-pagination.js';
import {CarouselNavigation} from './elements/carousel-navigation.js';

function loadPolyfills() {
  const polyfills = [];

  if (! isPopoverSupported()) {
    polyfills.push(import('@oddbird/popover-polyfill'));
  }

  return Promise.all(polyfills);
}

function bootApplication() {
  document.querySelectorAll('[role="banner"]').forEach((banner) => {
    const originalTheme = banner.dataset.theme || 'default';

    const updateBanner = (status) => {
      banner.dataset.theme = status ? 'default' : originalTheme;
      banner.classList.toggle('is-stuck', status);
    };

    whenStuck(banner, updateBanner, {offset: 200});
  });

  document.querySelectorAll('.drawer').forEach((drawer) => {
    drawer.addEventListener('click', function (event) {
      const anchor = event.target.closest('a');

      if (! anchor) {
        return;
      }

      drawer.hidePopover();
    });
  });

  document.querySelectorAll('button[data-dialogtarget]').forEach((button) => {
    const dialog = document.getElementById(button.dataset.dialogtarget);
    const action = button.dataset.dialogtargetaction || 'toggle';

    button.addEventListener('click', function () {
      if (action === 'show') {
        dialog.showModal();
      } else if (action === 'hide') {
        dialog.close();
      } else {
        dialog.open ? dialog.close() : dialog.showModal();
      }
    });
  });

  window.customElements?.define('via-carousel', Carousel);
  window.customElements?.define('via-carousel-track', CarouselTrack);
  window.customElements?.define('via-carousel-reel', CarouselReel);
  window.customElements?.define('via-carousel-item', CarouselItem);
  window.customElements?.define('via-carousel-pagination', CarouselPagination);
  window.customElements?.define('via-carousel-navigation', CarouselNavigation);
}

function handleExceptions(error) {
  //
}

loadPolyfills()
  .then(bootApplication)
  .catch(handleExceptions);